import { createErrorMapFunction } from 'pages/utils/errors';
import { getEnvFromHostname, ENVIRONMENTS } from 'pages/utils/getEnvFromHostname';

export const formatErrorsForFormik = createErrorMapFunction({
  'shopSetup.id': 'id',
  'shopSetup.address1': 'address1',
  'shopSetup.address2': 'address2',
  'shopSetup.city': 'city',
  'shopSetup.zipcode': 'zipcode',
  'shopSetup.countryCode': 'countryCode',
  'shopSetup.countryName': 'countryName',
  'shopSetup.regionName': 'regionName',
  'shopSetup.regionCode': 'regionCode',
  'shopSetup.name': 'name',
  'shopSetup.phoneNumber': 'phoneNumber',
  'shopSetup.email': 'email',
});

export const validateTaxRate = taxRate =>
  taxRate ? /^\d{1,3}(?:\.\d{1,7})?$/.test(taxRate) : true;

export const getGooglePlacesToken = () => {
  switch (getEnvFromHostname()) {
    case ENVIRONMENTS.PRODUCTION:
      // retail-location-service-prd-sre-5322
      return 'AIzaSyDRLo7Nf-3uY6xlooBCue6fCJlTGsWvTKM';
    case ENVIRONMENTS.STAGING:
      // retail-location-service-stg-sre-5322
      return 'AIzaSyCEf4IYTKSe8QgpdfuOjNGoEtSbrF-l440';
    default:
      // retail-location-service-sbx-sre-5322
      return 'AIzaSyD713YygFAjDcaAUlpeHzBtGm-e3jMYIQs';
  }
};
